import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null,
      currentPath: window.location.pathname 
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log to console only (safe for production)
    console.error('Routing Error:', error);
    console.error('Error Info:', errorInfo);
    console.error('Current Path:', window.location.pathname);
    console.error('Full URL:', window.location.href);
    
    this.setState({
      error,
      errorInfo,
      currentPath: window.location.pathname
    });

    // Optional: Send to error tracking service (remove sensitive data)
    // if (window.location.hostname !== 'localhost') {
    //   // Send error to monitoring service
    // }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '20px',
          maxWidth: '800px',
          margin: '50px auto',
          fontFamily: 'Arial, sans-serif',
          direction: 'rtl',
          textAlign: 'right'
        }}>
          <h2 style={{ color: '#d32f2f' }}>שגיאת ניתוב (Routing Error)</h2>
          <p><strong>נתיב שביקשת:</strong> <code>{this.state.currentPath}</code></p>
          <p><strong>URL מלא:</strong> <code>{window.location.href}</code></p>
          
          <details style={{ marginTop: '20px' }}>
            <summary style={{ cursor: 'pointer', color: '#007237', fontWeight: 'bold' }}>
              פרטי שגיאה (לפיתוח)
            </summary>
            <pre style={{
              background: '#f5f5f5',
              padding: '15px',
              borderRadius: '5px',
              overflow: 'auto',
              marginTop: '10px',
              fontSize: '12px'
            }}>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </pre>
          </details>

          <div style={{ marginTop: '20px' }}>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null, errorInfo: null });
                window.location.href = '/';
              }}
              style={{
                padding: '10px 20px',
                backgroundColor: '#007237',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              חזור לעמוד הראשי
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
